import { ReactNode } from 'react';
import styled from 'styled-components';
import { body2, colors, spacing } from 'ui/theme';

export const ENABLED_ALERTS_LIST_TEST_ID = 'enabled-alerts-list';

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  ${body2}
  color: ${colors.textPrimary};
`;

type EditableAlertsProps = {
  /** List of alert details to display */
  alertDetails: string[];
  /** Default value to display when there are no alerts */
  defaultValue?: ReactNode;
};

export const EnabledAlertsList = ({ alertDetails, defaultValue }: EditableAlertsProps) => {
  return alertDetails?.length > 0 ? (
    <List data-test={ENABLED_ALERTS_LIST_TEST_ID}>
      {alertDetails.map((alertDetail) => (
        <ListItem key={alertDetail}>{alertDetail}</ListItem>
      ))}
    </List>
  ) : (
    defaultValue
  );
};
